// Webpack Imports
import 'bootstrap';


(function ($) {
    'use strict';

    // Focus Search if Searchform is empty
    $('.search-form').on('submit', function (e) {
        var search = $('#s');
        if (search.val().length < 1) {
            e.preventDefault();
            search.focus();
        }
    });

}(jQuery));

//TODO: ORGANIZE SCRIPTS

$(function () {

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    }

    function getCookie(name) {
        var value = "; " + document.cookie;
        var parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    //Site Banner - Global
    $('.site-banner .alert').on('closed.bs.alert', function (e) {
        setCookie('c_site_banner_closed', true, 30);
    });
    if (getCookie('c_site_banner_closed') == null) {
        $('.site-banner').removeClass('d-none');
    };

    //Wisely Behavior
    if (window.matchMedia("(min-width: 769px)").matches) {
        $('.single-locations.single').on('click touch', function () {
            if ($('#wisely-reservations-backdrop').attr('aria-hidden') == 'false') {
                $('.single-locations.single').addClass('overflow-hidden');
            } else {
                $('.single-locations.single').removeClass('overflow-hidden');
            }
        });
    }

    // Hero banner overlay
    
    if (window.matchMedia("(max-width: 991.98px)").matches) {
        // The viewport is less than 768 pixels wide
        $(".hero-sm").css("--overlay-height", $(".hero-sm .hero-overlay .container").height() + 175 + "px");
        // $(".hero-overlay").animate({ top: 0, opacity: "show" }, 1500);
        $(".category-section-row-desktop").addClass('d-none').removeClass('d-flex');
        $(".category-section-row-mobile").removeClass('d-none').addClass('d-flex');
        $(".menu-item-modal-trigger").attr('data-target', '#mainNavModal');
    } else {
        // The viewport is at least 768 pixels wide
        // $(".hero-overlay").animate({ left: 0, opacity: "show" }, 1500);
        $(".category-section-row-desktop").removeClass('d-none').addClass('d-flex');
        $(".category-section-row-mobile").addClass('d-none').removeClass('d-flex');
        $(".menu-item-modal-trigger").attr('data-target', '#mainNavModalLg');
    }
    if (window.matchMedia("(max-width: 767.98px)").matches) {
        $(".hero-sm").css("--overlay-height", $(".hero-sm .hero-overlay .container").height() - 100 + "px");
    }
    

    $(window).on('resize', function () {
        if (window.matchMedia("(max-width: 991.98px)").matches) {
            // The viewport is less than 768 pixels wide
            $(".category-section-row-desktop").addClass('d-none').removeClass('d-flex');
            $(".category-section-row-mobile").removeClass('d-none').addClass('d-flex');
        } else {
            // The viewport is at least 768 pixels wide
            $(".category-section-row-desktop").removeClass('d-none').addClass('d-flex');
            $(".category-section-row-mobile").addClass('d-none').removeClass('d-flex');
        }
    });

    // Smooth Scroll Anchors
    var $root = $('html, body');
    $('a.cta-anchor, .cta-anchor a, .text-section a[href*=#]').on('click touch', function () {
        if (window.matchMedia("(max-width: 991.98px)").matches) {
            // The viewport is less than 768 pixels wide
            $root.animate({
                scrollTop: $($.attr(this, 'href')).offset().top - 130
            }, 500);
        } else {
            // The viewport is at least 768 pixels wide
            $root.animate({
                scrollTop: $($.attr(this, 'href')).offset().top - 80
            }, 500);
        }
        return false;
    });

    if (jQuery(this).find('.locations-template .entry-title').text() == jQuery('#btn-fyl-text').text()) {
        jQuery(this).find('.locations-template .btn-syl').addClass('active');
    }

    $('.category-button-link .cta-button').on('click touch', function () {
        $(this).toggleClass("active");
        if ($(this).hasClass("active")) {
            $(this).text("View Less -");
        } else {
            $(this).text("View More +");
        }
    });

    (function(){
        let $execTeam = $('.page-id-26 .exec-cards');
        if ($execTeam.find('.member-item').length > 2) return;
        if ($execTeam.find('.member-item').length == 2) {
            $execTeam.find('.container').addClass('justify-content-center-lg');
            return;
        }
        $execTeam.find('.container').addClass('justify-content-center flex-items-1');
    })();

    $('.locations-template a.btn-syl').on('click touch', function () {
        var postId = $(this).attr('id');
        var dropdownHTML = {
          'desktop': '<a id="fylBtn" class="btn btn-sm mx-2 my-3 btn-light" href="/locations"><i class="fas fa-map-marker"></i><span id="btn-fyl-text"> Find a Restaurant </span></a>',
          'mobile':  '<a id="fylBtn" class="btn btn btn-sm btn-light w-100 py-2 px-0" href="/locations"><i class="fas fa-map-marker"></i><span id="btn-fyl-text">Find a Restaurant</span></a>'
        }

        $(this).hasClass('active') ? ajaxCall(0, dropdownHTML) : ajaxCall(postId, '');;
        $(this).toggleClass('active').trigger('blur');

        function ajaxCall(postId, dropdown) {
            $.ajax({
                type: "POST",
                url: "https://" + location.hostname + "/wp-admin/admin-ajax.php",
                data: {
                    action: 'set_your_location',
                    'post_id': postId
                },
                success: function (data) {
                    $.ajax({
                        type: "POST",
                        url: "https://" + location.hostname + "/wp-admin/admin-ajax.php",
                        data: {
                            action: 'location_dropdown_content',
                        },
                        success: function (data) {
                            if (Object.keys(dropdown).length > 0) {
                                $('#dropdownFylBtnWrapper').html(dropdown.desktop);
                                $('#dropdownFylBtnWrapperMobile').html(dropdown.mobile);
                            } else {
                                $('#dropdownFylBtnWrapper').html(data);
                                $('#dropdownFylBtnWrapperMobile').html(data);
                            }
                            
                        },
                        error: function (xhr, textStatus, error) {
                            console.log(error);
                            console.log('dropdown fail');
                        }
                    });
                },
                error: function (xhr, textStatus, error) {
                    console.log(error);
                    console.log('location fail');
                }
            });
        }
    });

    if ($('.wpcf7').length == 1) {
        var wpcf7Elm = document.querySelector('.wpcf7');
        wpcf7Elm.addEventListener('wpcf7submit', function (event) {
            $('.contact-us-form-wrapper').fadeOut();
            setTimeout(function () {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".wpcf7-form").offset().top - 100
                }, 500);
            }, 500);
            //console.log("Submited");
        }, false);
    }

});

// Hero banner overlay
// $(document).ready(function(){
//     if(window.matchMedia("(max-width: 991.98px)").matches){
//         // The viewport is less than 768 pixels wide
//         $(".hero-overlay").animate({top:0, opacity:"show"}, 1500);
//     } else{
//         // The viewport is at least 768 pixels wide
//         $(".hero-overlay").animate({left:0, opacity:"show"}, 1500);
//     }
// });

// $(document).ready(function(){
//     $(".hero-overlay").animate({left:0, opacity:"show"}, 1500);
// });

// Main nav dropdown (click on mobile)
jQuery(function ($) {
    // Bootstrap menu magic
    if ($(window).width() < 991.98) {
        $(".dropdown-toggle").attr('data-toggle', 'dropdown');
        $('.dropdown').on('show.bs.dropdown', function () {
            $(this).siblings('.show').removeClass('show').find('a.dropdown-toggle').attr('data-hover', 'dropdown');
            $(this).find('a.dropdown-toggle').removeAttr('data-hover');
        });
    }
});

$('.grid').isotope({
    // set itemSelector so .grid-sizer is not used in layout
    itemSelector: '.grid-item',
    percentPosition: true,
    layoutMode: 'fitRows',
    masonry: {
        // use element for option
        columnWidth: '.grid-sizer'
    }
});

// Make Specials Cards redirect to their child link
if ($('.specials-cards .card a').length > 0) {
    $('.specials-cards .card a').each(function(cta) {
        $(this).closest('.card').attr('tabindex', '0');
        $(this).closest('.card').addClass('card-cta')
        if ($(this).attr('href').indexOf(window.location.hostname) === -1) {
            $(this).attr('target', '_blank');
            $(this).attr('rel', 'noopener noreferrer');
        }
        $(this).closest('.card').on('click keyup', function(e){
            let $cta = $(this).find('a');
            let $url = $cta.attr('href');
            let $target = $cta.attr('target') ? $cta.attr('target') : '_self';
            let $features = $cta.attr('rel') === 'noopener noreferrer';
            
            if (e.type == 'click' || e.keyCode == 13) {
                if ($target) {
                    window.open($url, $target);
                } else if ($target && $features) {
                    window.open($url, $target, $features);
                } else {
                    window.open($url);
                }
            }
        });
    });

}

// Accessibility Improvements
$('.caret').attr('role', 'presentation');
$('[data-hover="dropdown"]').attr('role', 'button');
$('.navbar-nav').attr('role', 'navigation');
$('[target="_blank"]').append('<span class="sr-only">Link opens in new tab</span>')
$('i.fas').attr('role', 'presentation');

$('#skip-content').attr('href', function(){
    let targetId = '#';
    if ($('main').length === 1) {
        $('main').attr('id', 'maincontent')
        targetId = '#maincontent';
    } else if ($('#jumbotron').length > 0) {
        targetId = '#jumbotron';
    } else {
        targetId = '#wrapper';
    }
    return targetId;
});

// CF7 Restrict Upload File Types 
$('.contact-us-form-wrapper #mfcf7_zl_multifilecontainer .mfcf7-zl-multiline-sample input.wpcf7-multilinefile').attr('accept', '.png, .jpg, .pdf');

(function() {
    var s = document.createElement('script');
    var h = document.querySelector('head') || document.body;
    s.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    s.async = true;
    s.onload = function() {
        acsbJS.init({
            statementLink : '',
            footerHtml : '',
            hideMobile : false,
            hideTrigger : false,
            disableBgProcess : false,
            language : 'en',
            position : 'right',
            leadColor : '#146FF8',
            triggerColor : '#146FF8',
            triggerRadius : '50%',
            triggerPositionX : 'right',
            triggerPositionY : 'bottom',
            triggerIcon : 'people',
            triggerSize : 'bottom',
            triggerOffsetX : 20,
            triggerOffsetY : 20,
            mobile : {
                triggerSize : 'small',
                triggerPositionX : 'right',
                triggerPositionY : 'bottom',
                triggerOffsetX : 20,
                triggerOffsetY : 20,
                triggerRadius : '20'
            }
        });
    };
    h.appendChild(s);
})();
